import styled from 'styled-components';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';

export const Container = styled.div`
  padding: 30px 24px 24px 16px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.06);
`;

export const Header = styled.div`
  color: ${props => props.theme.cornFlower};
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;

  h1 {
    font-size: ${pxToRem(20)};
    font-weight: 300;
    margin: 0;
  }
`;

export const Content = styled.div`
  padding-top: 6px;
  font-size: ${pxToRem(16)};
  font-weight: 300;
  color: ${props => props.theme.grey};
`;



// WEBPACK FOOTER //
// ./src/app/order-card/completed/header/styles.js